import React, { useState } from 'react';
import * as S from './styles';

import Modal from 'components/Modal';
import { Info } from 'types/BlogProps';
import { generateUid } from 'utils/functions';
import SimpleInput from 'components/SimpleInput';
import EditorQuill from 'components/EditorQuill';

type FormToAddContentProps = {
	isOpenForm: boolean;
	contentToEdit: Info | null;
	resetForm: () => void;
	// eslint-disable-next-line no-unused-vars
	excFunctionWhenClicksOnSaveBtn: (img: Info) => void;
};

const initialContent: Info = {
	id: '',
	text: '',
	urlImg: ''
};

export default function FormToAddContent({
	contentToEdit,
	excFunctionWhenClicksOnSaveBtn,
	isOpenForm,
	resetForm
}: FormToAddContentProps) {
	const [content, setContent] = useState<Info>(
		contentToEdit === null
			? { ...initialContent, id: generateUid() }
			: contentToEdit
	);

	return (
		<Modal
			isOpenProps={isOpenForm}
			setIsOpenModal={() => {
				resetForm();
			}}
			title={contentToEdit === null ? 'Adicionar' : 'Editar'}
			buttonClose={false}
		>
			<S.container>
				<S.twoInputs>
					<SimpleInput
						label="Url do video do Youtube ou imagem"
						initialValue={content.urlImg}
						getValue={(value: string) => {
							setContent((obj) => ({
								...obj,
								urlImg: value || ''
							}));
						}}
					/>

					<EditorQuill
						title="Descrição"
						value={content.text}
						onChange={(value: string) => {
							setContent((obj) => ({ ...obj, text: value }));
						}}
					/>
				</S.twoInputs>

				<S.containerBtns>
					<S.cancel
						data-testid="cancelBtn"
						onClick={() => {
							resetForm();
						}}
					>
						Cancelar
					</S.cancel>
					<S.save
						data-testid="saveBtn"
						onClick={() => {
							resetForm();
							excFunctionWhenClicksOnSaveBtn(content);
						}}
					>
						Salvar
					</S.save>
				</S.containerBtns>
			</S.container>
		</Modal>
	);
}
